module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words clear"
  }, [_c('div', [_c('h4', {
    staticClass: "selectWords-title"
  }, [_vm._v(_vm._s(_vm.resourceName))]), _vm._v(" "), (_vm.selectFlag) ? _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "checkKuang fl",
    class: {
      checked: _vm.isAllChecked, chooseSome: _vm.selectTextArr.length != 0 && _vm.selectTextArr.length < _vm.followreadText.length
    },
    on: {
      "click": _vm.allCheck
    }
  }), _vm._v(" "), _c('span', [_vm._v("全选")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main clear"
  }, _vm._l((_vm.followreadText), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wordsContent",
      class: {
        'active': item.isChecked
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.checkFun(item, index)
        }
      }
    }, [(index % 4 == 0 && _vm.selectFlag) ? _c('div', {
      staticClass: "singleChoice",
      class: {
        checked: _vm.singleChoiceArr[Math.ceil(index / 4)] === 2, chooseSome: _vm.singleChoiceArr[Math.ceil(index / 4)] === 1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.singleChoice(index, '1')
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "title",
      attrs: {
        "title": item.content
      }
    }, [_vm._v(_vm._s(item.content))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "bottomMenu clearfix"
  }, [_c('div', {
    staticClass: "bottomMenuBox clearfix"
  }, [(_vm.selectTextArr.length != 0) ? _c('div', {
    staticClass: "fl",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("共选\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.selectTextArr.length || 0))]), _vm._v("\n                个单词, 预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDataToMinute")(_vm.doworkTime)))]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('span', {
    staticClass: "cancel fl",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button confirm",
    on: {
      "click": _vm.backSentenceArr
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3181c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/readWords/readWords.vue
// module id = 1175
// module chunks = 1